import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649406bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-history" }

import { recProps } from '../../mixins/rec-component';
  
  import SimpleButton from "vue/applications/frontend/components/simple-button.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-history',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.content.entries, (entry) => {
      return (_openBlock(), _createBlock(SimpleButton, {
        "use-theming": "",
        class: "history-button",
        key: entry.id,
        "link-target": entry.target_path,
        filled: entry.active
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(entry.label), 1)
        ]),
        _: 2
      }, 1032, ["link-target", "filled"]))
    }), 128))
  ]))
}
}

})